'use client';
import Dialog from '@ui/Dialog';
import useJoinNonProfitDialogStore from '@/components/store/joinNonProfitDialogSlice';
import React, { useState } from 'react';
import GuestJoinNonProfitForm from './GuestJoinNonProfitForm';
import Image from 'next/image';
import { ScrollArea } from '@ui/ScrollArea';
import useHasUserSession from '@/hooks/useHasUserSession';
import UserJoinNonProfitForm from './UserJoinNonProfitForm';
import useNonProfitStore from '../InitNonProfitStore/store';
import getQualifiedImageUrl from '@/utils/imageUrlProcessor';
import { DEFAULT_USER_BANNER_IMAGE } from '@/constants/neki.constant';
import Avatar from '@ui/Avatar';
import Typography from '@/components/next-ui/Typography/Typography';
import Link from '@/components/next-ui/Link/Link';
import ShareButton from '../ShareButton';
import { useBreakpointHooks } from '@/utils/break-points.provider';
import { cx } from 'cva';

function JoinNonProfitDialog(props) {
  const isSmallScreen = useBreakpointHooks((bp) => bp.useSmaller('md'));
  const isOpen = useJoinNonProfitDialogStore((state) => state.open);
  const nonProfitFromDialog = useJoinNonProfitDialogStore(
    (state) => state.nonProfit,
  );
  const step = useJoinNonProfitDialogStore((state) => state.step);
  const nonProfitFromStore = useNonProfitStore((state) => state.nonProfit);
  const setIsOpen = useJoinNonProfitDialogStore((state) => state.setOpen);
  const auth0User = useJoinNonProfitDialogStore((state) => state.auth0User);
  const hasUserSession = useHasUserSession();
  const nonProfit = nonProfitFromDialog || nonProfitFromStore;
  let dialogTitle = nonProfit
    ? `Join ${nonProfit.name} Community!`
    : `Join Community!`;

  const logoUrl = nonProfit?.company?.logoUrl || nonProfit?.logo_url;

  if (isSmallScreen) {
    dialogTitle =
      dialogTitle.length > 20 ? `${dialogTitle.slice(0, 20)}...` : dialogTitle;
  }

  const [formData, setFormData] = useState({});

  function closeModal() {
    setIsOpen(false);
  }

  function onSubmit() {
    closeModal();
  }

  return (
    <Dialog
      isOpen={isOpen}
      onClose={closeModal}
      maxWidth="lg"
      // noClose={true}
      title={dialogTitle}
      titleClass="!text-center"
      iconUrl={logoUrl}>
      <div className="flex w-full flex-col gap-6 lg:flex-row">
        {hasUserSession ? (
          <div className="hidden max-w-sm flex-shrink-0 flex-grow-0 items-center justify-center lg:flex lg:flex-[0.4]">
            <Image
              width={333}
              height={303}
              src="/assets/images/public-connect-modal-image.jpg"
              alt="background image"
              priority
            />
          </div>
        ) : (
          <div className="hidden max-w-sm flex-col items-center lg:flex lg:flex-[0.4]">
            <Typography variant="h3">Profile Preview</Typography>
            <div className="relative mt-7 aspect-[4] w-full">
              <Image
                src={getQualifiedImageUrl(DEFAULT_USER_BANNER_IMAGE)}
                alt="banner"
                layout="fill"
                objectFit="cover"
              />
            </div>
            <div className="relative mt-6 flex w-full flex-1">
              <div className="absolute -top-[38px] left-[50px]">
                <Avatar src={null} alt={formData.first_name} size="md" />
              </div>
              <div className="absolute -top-[20px] right-[10px] scale-75">
                <ShareButton variant="text" disabled />
              </div>
              <div className="scale-90">
                <div>
                  <div className="flex flex-row items-center gap-3.5">
                    <Typography variant="h4" component="h1">
                      {formData?.fullName?.length > 20
                        ? `${formData?.first_name?.slice(
                            0,
                            10,
                          )} ${formData?.last_name?.slice(0, 10)}...`
                        : formData.fullName}
                    </Typography>
                  </div>
                  <Typography variant="h5">
                    {formData && formData?.designation?.slice(0, 10)}{' '}
                    {formData && formData?.companyName && 'at'}{' '}
                    {formData && (
                      <Link href="#">
                        {formData?.companyName?.slice(0, 20)}
                      </Link>
                    )}
                  </Typography>
                  <Typography variant="h5">
                    {formData && formData?.city?.slice(0, 10)}{' '}
                    {formData?.state?.slice(0, 10)} {formData.country}
                  </Typography>
                  <div>
                    <Typography
                      variant="subtitle1"
                      color="hyperlink"
                      className="cursor-pointer">
                      Contact Info.
                    </Typography>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        <div className="flex w-full min-w-[200px] flex-col lg:flex-[0.6]">
          <ScrollArea className="w-full flex-1 lg:pr-4">
            <div className={cx('w-full pb-2', isSmallScreen && 'mb-20')}>
              {hasUserSession ? (
                <UserJoinNonProfitForm
                  nonProfit={nonProfit}
                  onSubmit={onSubmit}
                  stepFromStore={step}
                />
              ) : (
                <GuestJoinNonProfitForm
                  nonProfit={nonProfit}
                  onSubmit={onSubmit}
                  user={auth0User}
                  handleFormData={setFormData}
                />
              )}
            </div>
          </ScrollArea>
        </div>
      </div>
    </Dialog>
  );
}

export default JoinNonProfitDialog;
